export default "__VITE_ASSET__VL$JjVx$__"